/**
 * @fileoverview POST handler for the "/companies/:company_id/developers/:developer_id/suspend" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersDeveloperIdSuspendCacheKeys } from "./constants";
import type { PostCompaniesCompanyIdDevelopersDeveloperIdSuspendProps, DeveloperSuspendResult } from "./types";

export const postDeveloperSuspend = reactQueryMutationAdapter(
  companiesCompanyIdDevelopersDeveloperIdSuspendCacheKeys,
  (props: PostCompaniesCompanyIdDevelopersDeveloperIdSuspendProps): Promise<DeveloperSuspendResult> => {
    return fetch(`/companies/${props.companyId}/developers/${props.developerId}/suspend`, "POST", props);
  }
);
